const Resources = {

    table_headers: [
        { 
            text:   'Associate',
            align:  'start',
            value:  'associate'
        },
        {   
            text:   'Assignment',
            value:  'daily_assignment'
        },
    ],

    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Days Off',
            href:   '#',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Master Days Off',
            href:   '/days-off-templates',
            arrow:  "",
        },
    ],

    excel_file_headers: 
    {
        'Assignment Number': 'Assignment Number',
    },

    empty_format_data: [
        {
            'Assignment': '',
            'Associate': '',
        }
    ],

    helps: [
        {
            label: '¿How to use the Master Days Off?', 
            instruction: `https://scribehow.com/embed/How_to_Use_the_Master_Days_Off__GfEhj_ZaSWu8fSfePR4rrQ?as=scrollable`
        },
        {
            label: '¿How to add associates on Master Days Off Templates?', 
            instruction: `https://scribehow.com/embed/How_To_Add_Associates_On_Master_Days_Off_Templates__9WXIBvevSYmnEfZu7OaMWA?as=scrollable`
        },
    ]

}

export default Resources;